import _ from 'underscore';
import Util from 'root/module/util';
import View from 'view/base';

var Country_View = View.extend({
    initialize: function(chart_data) {
        this.chart_data = chart_data;
    },

    events: {
        'click .view-more': 'viewMore'
    },

    dom_handlers: {
        viewMore: function(e) {
            e.preventDefault();
            this.$el.find('tr').show();
            this.$el.find('.view-more').parents('tr:first').remove();
        }
    },

    render: function() {
        var html = '';

        html += '<table class="medium">' +
                '<tr>' +
                '<th>Country</th>' +
                '<th width="50%">Feedback</th>' +
                '</tr>';
        var total = 0;
        _.each(this.chart_data, function(count, country) {
            total += count;
        });

        var min_row = 5;
        var index = 0;
        _.each(this.chart_data, function(count, country) {
            var percentage = 0;

            if (total) {
                percentage = count / total * 100;
            }

            html += '<tr' + (index >= min_row ? ' style="display:none;"' : '') + '>' +
                    '<td>' + Util.htmlEntities(country) + ' </td>' +
                    '<td><div class="meteor-primary margin-bottom-4"><div><span style="width:' + percentage + '%;"></span></div></div>' + count + '</td>' +
                    '</tr>';

            index++;
        });

        if (_.size(this.chart_data) < min_row) {
            for (var i = 0; i < (min_row - _.size(this.chart_data)); i++) {
                html += '<tr class="empty"><td colspan="2" height="67"></td></tr>';
            }
        }

        if (_.size(this.chart_data) > min_row) {
            html += '<tr class="empty"><td colspan="2" align="right"><a href="#" class="primary view-more"><b>View More</b></a></td></tr>';
        }

        html += '</table>';


        this.$el.html(html);

        return this;
    }
});

export default Country_View;